export default {
	click_instance_to_browse_content: 'Click on an instance to browse its content.',
	click_instance_to_see_results: 'Click on an instance to see the results for that instance.',

	column_configurator_add_all: 'Add all',
	column_configurator_add_selected: 'Add selected',
	column_configurator_available_columns: 'Available Columns',
	column_configurator_cancel_button: 'Cancel',
	column_configurator_disabled_global_mode: 'Column configuration not available in global mode',
	column_configurator_displayed_columns: 'Displayed Columns',
	column_configurator_first_column: 'First Column',
	column_configurator_move_down: 'Move down',
	column_configurator_move_up: 'Move up',
	column_configurator_no_columns_hint: 'Select columns from the left list',
	column_configurator_no_columns_selected: 'No columns selected',
	column_configurator_remove_all: 'Remove all',
	column_configurator_remove_column: 'Remove column',
	column_configurator_remove_directly: 'Remove directly',
	column_configurator_remove_selected: 'Remove selected',
	column_configurator_reset_button: 'Reset to defaults',
	column_configurator_reset_confirm_cancel: 'Cancel',
	column_configurator_reset_confirm_message:
		'Do you really want to reset the column configuration to default values?',
	column_configurator_reset_confirm_ok: 'Yes, reset',
	column_configurator_reset_confirm_title: 'Reset to defaults',
	column_configurator_save_button: 'Save',
	column_configurator_save_success: 'Column configuration saved',
	column_configurator_search_placeholder: 'Search columns...',
	column_configurator_selected_count: '{count} selected',
	column_configurator_subtitle: 'Select the columns to display and determine their order using drag & drop.',
	column_configurator_title: 'Configure Columns',

	global_search_exiting: 'Leaving global search mode...',
	global_search_loading: 'Global search running...',
	global_search_results_available: 'Search results available',
	global_search_searching_for: 'Searching all files for "{searchTerm}"...',
	ido_add_ido_favorite: 'Favorite',
	ido_button_search_dialog_close: 'Apply',
	ido_button_search_dialog_close_and_apply: 'Close',
	ido_button_search_empty_title: 'Start search',
	ido_button_search_minimum_input_label: 'Enter at least 3 characters.',
	ido_button_search_no_display_field_value: 'Display field is empty, please complete',
	ido_button_search_no_matches_label: 'No matching datasets were found for this search.',
	ido_button_search_no_preview_label: 'No additional preview data available',
	ido_button_search_no_results: 'No Results',
	ido_button_search_no_results_title: 'No matches',
	ido_button_search_select_label: 'Search digital files to link',
	ido_button_unlink_label: 'Unlink',
	ido_calculation_no_data_hint: 'No numeric values available for calculation.',
	ido_calculation_summary_scope_tooltip: 'Σ / ∅ / Min / Max apply to the full list, not just the current page.',
	ido_calculation_toggle_disable_tooltip: 'Disable calculation row',
	ido_calculation_toggle_enable_tooltip: 'Enable calculation row',
	ido_changelog_action_delete:
		'<span class="ido-cl-user">{user}</span> <span class="ido-cl-verb-neg">deleted</span> the <span class="ido-cl-value">record</span>',
	ido_changelog_action_deselect_multiple_choice:
		'<span class="ido-cl-user">{user}</span> <span class="ido-cl-verb-neg">deactivated</span> the value <span class="ido-cl-value">{value}</span> in the <span class="ido-cl-field">multiple choice field {field}</span>',
	ido_changelog_action_deselect_single_choice:
		'<span class="ido-cl-user">{user}</span> <span class="ido-cl-verb-pos">deselected</span> the value in the <span class="ido-cl-field">single choice field {field}</span>',
	ido_changelog_action_fix_next_contact:
		'<span class="ido-cl-user">{user}</span> <span class="ido-cl-verb-pos">activated</span> the <span class="ido-cl-field">highlight</span> of the <span class="ido-cl-value">next contact</span>',
	ido_changelog_action_select_multiple_choice:
		'<span class="ido-cl-user">{user}</span> <span class="ido-cl-verb-pos">activated</span> the value <span class="ido-cl-value">{value}</span> in the <span class="ido-cl-field">multiple choice field {field}</span>',
	ido_changelog_action_select_single_choice:
		'<span class="ido-cl-user">{user}</span> <span class="ido-cl-verb-pos">selected</span> the value <span class="ido-cl-value">{value}</span> in the <span class="ido-cl-field">single choice field {field}</span>',
	ido_changelog_action_set_archive:
		'<span class="ido-cl-user">{user}</span> <span class="ido-cl-verb-pos">updated</span> the <span class="ido-cl-field">archive</span> with the value <span class="ido-cl-value">{value}</span>',
	ido_changelog_action_set_contact_person:
		'<span class="ido-cl-user">{user}</span> <span class="ido-cl-verb-pos">set</span> the <span class="ido-cl-field">contact person</span> to <span class="ido-cl-value">{value}</span>',
	ido_changelog_action_set_hint:
		'<span class="ido-cl-user">{user}</span> <span class="ido-cl-verb-pos">updated</span> the <span class="ido-cl-field">hint</span> with the value <span class="ido-cl-value">{value}</span>',
	ido_changelog_action_set_last_contact_date:
		'<span class="ido-cl-user">{user}</span> <span class="ido-cl-verb-pos">set</span> the <span class="ido-cl-field">last contact date</span> to <span class="ido-cl-value">{value}</span>',
	ido_changelog_action_set_next_contact_date:
		'<span class="ido-cl-user">{user}</span> <span class="ido-cl-verb-pos">set</span> the <span class="ido-cl-field">next contact date</span> to <span class="ido-cl-value">{value}</span>',
	ido_changelog_action_set_next_contact_time:
		'<span class="ido-cl-user">{user}</span> <span class="ido-cl-verb-pos">set</span> the <span class="ido-cl-field">next contact time</span> to <span class="ido-cl-value">{value}</span>',
	ido_changelog_action_set_value:
		'<span class="ido-cl-user">{user}</span> <span class="ido-cl-verb-pos">updated</span> the <span class="ido-cl-field">input field {field}</span> with the value <span class="ido-cl-value">{value}</span>',
	ido_changelog_action_unfix_next_contact:
		'<span class="ido-cl-user">{user}</span> <span class="ido-cl-verb-neg">removed</span> the <span class="ido-cl-field">highlight</span> of the <span class="ido-cl-value">next contact</span>',
	ido_changelog_empty_title: 'No versions yet',
	ido_changelog_field_archive: 'Archive',
	ido_changelog_field_contact_person: 'Contact person',
	ido_changelog_field_highlight: 'Highlight',
	ido_changelog_field_hint: 'Hint',
	ido_changelog_field_last_contact: 'Last contact',
	ido_changelog_field_next_contact: 'Next contact',
	ido_changelog_field_next_contact_time: 'Contact time',
	ido_changelog_load_error: 'Versions could not be loaded',
	ido_changelog_tab_label: 'Versions',
	ido_context_menu_add_to_favorite: 'Add to favorites',
	ido_context_menu_clone_ido: 'Copy file into',
	ido_context_menu_create_task: 'Create task',
	ido_context_menu_delay_one_day: 'Tomorrow',
	ido_context_menu_delay_one_week: 'Next week',
	ido_context_menu_history: 'History',
	ido_context_menu_open_ido: 'Open file',
	ido_context_menu_relations_history: 'Relation history',
	ido_context_menu_today: 'Today',
	ido_copy: 'Copy',
	ido_copy_dialog_copy_ido: 'Copy dataset',
	ido_copy_dialog_to_the_instance: 'To the instance',
	ido_create_dialog_create_new_ido: 'Create new dataset',
	ido_create_dialog_in_the_instance: 'In the instance',
	ido_create_document: 'Upload documents',
	ido_create_memo: 'Create memo',
	ido_create_note: 'Create note',
	ido_create_task: 'Create task',
	ido_datefield_close: 'Close',
	ido_delete_dialog_confirm_cancel_label: 'No',
	ido_delete_dialog_confirm_message: 'Do you really want to delete this dataset?',
	ido_delete_dialog_confirm_ok_label: 'Yes',
	ido_delete_dialog_confirm_title: 'Delete dataset',
	ido_delete_error_message: 'The record could not be deleted.',
	ido_delete_stale_message:
		'The record was changed in the meantime and has not been deleted. The view has been refreshed — please review and delete again.',
	ido_detail_unavailable_message:
		'The server did not return record master data for this link. The link remains available, but the record cannot be displayed here.',
	ido_detail_unavailable_title: 'Record cannot be displayed',
	ido_details_search_add_condition: 'Condition',
	ido_details_search_add_group: 'Group',
	ido_details_search_autocomplete_hints_error: 'The search suggestions could not be loaded.',
	ido_details_search_date_dynamic_operation_currentCalendarWeek: 'current calendar week',
	ido_details_search_date_dynamic_operation_currentMonth: 'current month',
	ido_details_search_date_dynamic_operation_currentQuarter: 'current quarter',
	ido_details_search_date_dynamic_operation_currentYear: 'current year',
	ido_details_search_date_dynamic_operation_label: 'Date variant',
	ido_details_search_date_dynamic_operation_monthOfCurrentYear: 'month of current year',
	ido_details_search_date_dynamic_operation_nthDayOfCurrentMonth: 'day of current month',
	ido_details_search_date_dynamic_operation_nthWeekdayOfCurrentMonth: 'weekday of current month',
	ido_details_search_date_dynamic_operation_quarterOfCurrentYear: 'quarter of current year',
	ido_details_search_date_dynamic_operation_today: 'today',
	ido_details_search_date_dynamic_operation_weekdayOfCurrentCalendarWeek: 'weekday of current calendar week',
	ido_details_search_date_from_label: 'From',
	ido_details_search_date_interval_label: 'Amount',
	ido_details_search_date_month_april: 'April',
	ido_details_search_date_month_august: 'August',
	ido_details_search_date_month_december: 'December',
	ido_details_search_date_month_february: 'February',
	ido_details_search_date_month_january: 'January',
	ido_details_search_date_month_july: 'July',
	ido_details_search_date_month_june: 'June',
	ido_details_search_date_month_label: 'Month',
	ido_details_search_date_month_march: 'March',
	ido_details_search_date_month_may: 'May',
	ido_details_search_date_month_november: 'November',
	ido_details_search_date_month_october: 'October',
	ido_details_search_date_month_september: 'September',
	ido_details_search_date_nth_day_label: 'Day number',
	ido_details_search_date_nth_weekday_number_label: 'Week in month',
	ido_details_search_date_quarter_label: 'Quarter',
	ido_details_search_date_quarter_q1: 'Q1',
	ido_details_search_date_quarter_q2: 'Q2',
	ido_details_search_date_quarter_q3: 'Q3',
	ido_details_search_date_quarter_q4: 'Q4',
	ido_details_search_date_range_label: 'Time unit',
	ido_details_search_date_relative_range_day: 'Days',
	ido_details_search_date_relative_range_month: 'Months',
	ido_details_search_date_relative_range_quarter: 'Quarters',
	ido_details_search_date_relative_range_week: 'Weeks',
	ido_details_search_date_relative_range_year: 'Years',
	ido_details_search_date_terms_unsupported: 'This date variant will be completed in the next slice.',
	ido_details_search_date_to_label: 'To',
	ido_details_search_date_type_dynamic: 'dynamic',
	ido_details_search_date_type_fixed: 'fixed',
	ido_details_search_date_type_label: 'Date type',
	ido_details_search_date_weekday_friday: 'Friday',
	ido_details_search_date_weekday_label: 'Weekday',
	ido_details_search_date_weekday_monday: 'Monday',
	ido_details_search_date_weekday_saturday: 'Saturday',
	ido_details_search_date_weekday_sunday: 'Sunday',
	ido_details_search_date_weekday_thursday: 'Thursday',
	ido_details_search_date_weekday_tuesday: 'Tuesday',
	ido_details_search_date_weekday_wednesday: 'Wednesday',
	ido_details_search_dialog_active_count: '{count} active conditions',
	ido_details_search_dialog_apply: 'Apply',
	ido_details_search_dialog_cancel: 'Cancel',
	ido_details_search_dialog_dirty_hint: 'There are unapplied changes in this draft.',
	ido_details_search_dialog_draft_count: '{count} conditions in draft',
	ido_details_search_dialog_editor_pending_hint:
		'Field and term editors land in the next slice. Existing detail searches can already be reviewed and reset here.',
	ido_details_search_dialog_empty_body:
		'As soon as conditions are added, this dialog will show the structure of the current filter draft.',
	ido_details_search_dialog_empty_title: 'No detail filters configured yet',
	ido_details_search_dialog_reset: 'Reset',
	ido_details_search_dialog_title: 'Detail search',
	ido_details_search_field_label: 'Field',
	ido_details_search_field_values_error: 'The selectable values could not be loaded.',
	ido_details_search_fields_empty: 'No detail-search fields are available for this instance.',
	ido_details_search_fields_error: 'The available detail-search fields could not be loaded.',
	ido_details_search_fields_loading: 'Loading detail-search fields...',
	ido_details_search_geo_radius_country_label: 'Country',
	ido_details_search_geo_radius_km_label: 'Radius in km',
	ido_details_search_geo_radius_postal_code_label: 'Postal code',
	ido_details_search_group_empty_state: 'Add a condition or nested group.',
	ido_details_search_location_contact_person: 'Contact person',
	ido_details_search_location_master_data: 'Master data',
	ido_details_search_logical_operator_and: 'AND',
	ido_details_search_logical_operator_or: 'OR',
	ido_details_search_nested_group_label: 'Nested group',
	ido_details_search_operation_doesContain: 'contains',
	ido_details_search_operation_doesNotContain: 'does not contain',
	ido_details_search_operation_is: 'is',
	ido_details_search_operation_isAfter: 'is after',
	ido_details_search_operation_isAll: 'contains all',
	ido_details_search_operation_isAny: 'contains any of',
	ido_details_search_operation_isBefore: 'is before',
	ido_details_search_operation_isBeginningWith: 'starts with',
	ido_details_search_operation_isEmpty: 'is empty',
	ido_details_search_operation_isEndingWith: 'ends with',
	ido_details_search_operation_isGreaterThan: 'is greater than',
	ido_details_search_operation_isInRadiusSearch: 'is within radius',
	ido_details_search_operation_isInTheLast: 'is in the last',
	ido_details_search_operation_isInTheNext: 'is in the next',
	ido_details_search_operation_isInTheRange: 'is in range',
	ido_details_search_operation_isLessThan: 'is less than',
	ido_details_search_operation_isNot: 'is not',
	ido_details_search_operation_isNotAll: 'does not contain all',
	ido_details_search_operation_isNotAny: 'contains none of',
	ido_details_search_operation_isNotBeginningWith: 'does not start with',
	ido_details_search_operation_isNotEmpty: 'is not empty',
	ido_details_search_operation_isNotEndingWith: 'does not end with',
	ido_details_search_operation_isNotInTheLast: 'is not in the last',
	ido_details_search_operation_isNotInTheNext: 'is not in the next',
	ido_details_search_operation_isNotInTheRange: 'is not in range',
	ido_details_search_operation_isNotTrue: 'is not true',
	ido_details_search_operation_isTrue: 'is true',
	ido_details_search_operation_label: 'Operation',
	ido_details_search_remove_condition: 'Remove condition',
	ido_details_search_remove_group: 'Remove group',
	ido_details_search_root_group_label: 'Root group',
	ido_details_search_summary_chip_active: '{count} detail filters active',
	ido_details_search_summary_chip_dirty: 'Draft changed',
	ido_details_search_summary_chip_empty: 'Detail search',
	ido_details_search_summary_chip_more: 'more',
	ido_details_search_terms_label: 'Search value',
	ido_details_search_terms_not_required: 'This operation does not require a search value.',
	ido_details_search_terms_unsupported: 'This field type will be added in the next slice.',
	ido_details_search_toolbar_button_active_tooltip: 'Open detail search ({count} active conditions)',
	ido_details_search_toolbar_button_disabled_tooltip: 'Detail search is not available in this context yet',
	ido_details_search_toolbar_button_tooltip: 'Open detail search',
	ido_dirty_field_dialog_apply_remote: 'Apply server value',
	ido_dirty_field_dialog_empty_value: '(empty)',
	ido_dirty_field_dialog_field_summary: '{fieldName}: server value "{remoteValue}", your change "{localValue}"',
	ido_dirty_field_dialog_field_summary_with_change_metadata:
		'{fieldName}: was changed at {changedAt} by the user {fullUsername}. Server value "{remoteValue}", your change "{localValue}"',
	ido_dirty_field_dialog_keep_local: 'Keep my change',
	ido_dirty_field_dialog_message:
		'The record "{recordTitle}" was changed elsewhere.\n\n{conflicts}\n\nDo you want to apply the server value or keep your change?',
	ido_dirty_field_dialog_title: 'Competing change',
	ido_document_column_category: 'Category',
	ido_document_column_date: 'Date',
	ido_document_column_information: 'Description',
	ido_document_column_postbox: 'Postbox',
	ido_document_export_title: 'Documents',
	ido_document_filter_categories_label: 'Categories',
	ido_document_filter_categories_selected: "{'{'}0{'}'} categories",
	ido_document_filter_uncategorised: 'Uncategorised',
	ido_document_load_error: 'The documents could not be loaded.',
	ido_document_loading: 'Loading documents...',
	ido_document_no_results: 'No documents found.',
	ido_document_open_fallback_label: 'Open document',
	ido_document_page_of: "of {'{'}totalPages{'}'}",
	ido_document_page_report: 'Showing {first} - {last} of {totalRecords}',
	ido_document_save_list_context: 'The search and category filters of this document list are saved with it.',
	ido_document_save_list_name_placeholder: 'e.g. Invoices 2026',
	ido_document_save_list_tooltip: 'Create list',
	ido_document_search_placeholder: 'Search documents',
	ido_export_complete_combined_csv: 'Complete master data and contact person export as CSV',
	ido_export_complete_contact_person_csv: 'Complete contact person export as CSV',
	ido_export_complete_csv: 'Complete master data export as CSV',
	ido_export_complete_note_archive_csv: 'Note and archive export as CSV',
	ido_export_section_complete: 'Complete export',
	ido_export_section_page: 'Page export',
	ido_history_filter_deselect_all: 'Deselect all',
	ido_history_filter_hub: 'Filters',
	ido_history_filter_select_all: 'Select all',
	ido_history_module_filter: 'Module',
	ido_history_open_view: 'Open',
	ido_history_search_clear: 'Clear search input',
	ido_history_time_range_all: 'All',
	ido_history_time_range_filter: 'Time range',
	ido_history_time_range_four_weeks: '4 weeks',
	ido_history_time_range_seven_days: '7 days',
	ido_history_time_range_today: 'Day',
	ido_history_user_filter: 'User',
	ido_history_user_filter_groups: 'Groups',
	ido_idos_count: '{count} datasets',
	ido_idos_label: 'Datasets',
	ido_idos_show_all: 'Show all datasets',
	ido_instance_filter_clear_tooltip: 'Clear filter',
	ido_instance_filter_placeholder: 'Filter file types...',
	ido_instance_picker_empty: 'No record types available',
	ido_instance_sidebar_resize: 'Resize record type sidebar',
	ido_instance_sidebar_resize_reset_hint: 'Double-click to reset',
	ido_list_entries_loading: 'Loading record entries...',
	ido_list_global_search: 'Search all instances',
	ido_list_hidden_tabs_dialog_later_button: 'Remind me later',
	ido_list_hidden_tabs_dialog_message:
		'When you perform a global search, any open instance tabs are temporarily hidden. They will reappear when you clear the search. This keeps your workspace clean during global searches.',
	ido_list_hidden_tabs_dialog_ok_button: 'OK, understood',
	ido_list_hidden_tabs_dialog_title: 'Hidden Tabs Information',
	ido_list_hidden_tabs_indicator: 'hidden tabs',
	ido_list_hidden_tabs_tooltip: 'These tabs will reappear when you clear the global search.',
	ido_list_instance: 'Instance',
	ido_list_instance_search_mode: 'Activate instance search',
	ido_list_instance_search_mode_action: 'Search only selected instance',
	ido_list_instance_search_mode_tooltip: 'Switch back to instance search',
	ido_list_instances_all: 'Search all instances',
	ido_list_instances_all_action: 'Search all instances',
	ido_list_instances_all_tooltip: 'Switch to global search mode (all instances)',
	ido_list_loading: 'Loading records...',
	ido_list_mobile_next_page_tooltip: 'Next page',
	ido_list_mobile_page_input_label: 'Page',
	ido_list_mobile_page_status: 'Page {page} of {pageCount}',
	ido_list_mobile_previous_page_tooltip: 'Previous page',
	ido_list_mobile_rows_per_page_label: 'Rows',
	ido_list_no_lists_available: 'No lists available',
	ido_list_page_of: "of {'{'}totalPages{'}'}",
	ido_list_page_report: 'Showing {first} - {last} of {totalRecords}',
	ido_list_select_instance: 'Select record type',
	ido_list_select_instance_to_browse: 'Select record type to browse',
	ido_list_shared_query: 'Shared query',
	ido_list_table_height: 'Table height',
	ido_lists: 'Lists',
	ido_mail_attachment_column_contact: 'Contact',
	ido_mail_attachment_column_date: 'Date',
	ido_mail_attachment_column_filename: 'Filename',
	ido_mail_attachment_column_mailbox: 'Mailbox',
	ido_mail_attachment_load_error: 'The email attachments could not be loaded.',
	ido_mail_attachment_loading: 'Loading email attachments...',
	ido_mail_attachment_no_results: 'No email attachments found.',
	ido_mail_attachment_open_mail_fallback_label: 'Open email',
	ido_mail_attachment_page_of: "of {'{'}totalPages{'}'}",
	ido_mail_attachment_page_report: 'Showing {first} - {last} of {totalRecords}',
	ido_mail_attachment_search_placeholder: 'Search email attachments',
	ido_no_results: 'No results',
	ido_print_choose_data_source: 'Choose data…',
	ido_print_failed: 'Printing failed',
	ido_print_no_access: 'No access to this template',
	ido_print_search_placeholder: 'Search print templates',
	ido_relations_empty_message: 'No relations are available for this record.',
	ido_relations_empty_title: 'No Relations',
	ido_relations_history_invalid: 'The relation history could not be loaded.',
	ido_relations_history_title: 'Relation history',
	ido_relations_instance_empty_title: 'No entries in this record type',
	ido_relations_load_more: 'Load more',
	ido_relations_loaded_progress: '{loaded} of {total}',
	ido_relations_loading: 'Loading relations...',
	ido_relations_page_of: "of {'{'}totalPages{'}'}",
	ido_relations_page_report: 'Showing {first} - {last} of {totalRecords}',
	ido_save_error_message: 'The record could not be saved.',
	ido_save_stale_data_message:
		'The record was changed somewhere else in the meantime. Please review the current values and save again.',
	ido_save_stale_data_ok_label: 'OK',
	ido_save_stale_data_title: 'Record was changed',
	ido_send_message: 'Send message',
	ido_shared_query_save_as_context: 'The conditions of your current detail search are saved with it.',
	ido_shared_query_save_as_dialog_title: 'Save detail search as list',
	ido_shared_query_save_as_disabled_tooltip: 'There is no detail-search draft to save',
	ido_shared_query_save_as_field_label: 'List name',
	ido_shared_query_save_as_name_placeholder: 'e.g. Open cases – North',
	ido_shared_query_save_as_tooltip: 'Save the current detail-search draft as a list',
	ido_shared_query_save_error: 'The list could not be saved.',
	ido_shared_query_save_success: 'The list "{name}" has been saved.',
	ido_start_timer: 'Create timer',
	ido_toolbar_visibility_tooltip: 'Column visibility',
	ido_unknown_instance: 'Unknown instance',
	ido_validation_required_field: 'Required field.',
	loading: 'Loading...',
	no_shared_queries_available: 'No lists available',
	no_shared_queries_found: 'No lists found',
	no_shared_queries_placeholder: 'No saved lists available',
	search_all_instances_placeholder: 'Search across all instances...',
	search_in_instance_placeholder: 'Search in instance...',
	search_in_specific_instance_placeholder: 'Search in {name}...',
	search_shared_queries_placeholder: 'Search lists...',
	search_term: 'Search term',
	select_an_instance_to_view_results: 'Select an instance to view results',

	select_instance_to_browse: 'Select an instance to browse',
	select_instance_to_view_details: 'Select an instance from the left list to see the detailed results.',
	select_instance_to_view_results: 'Select an instance to view results',
	shared_queries_empty_hint: 'Create lists to see them here',
	shared_queries_label: 'Lists',
	shared_queries_placeholder: 'Select list...',
	shared_query_readonly_tooltip: 'Current list (not changeable)',
};
